import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { SubNav } from '../layout/submenu';

export const EquipmentGroupCard = ({ item, onSelect, selected }) => {
    const egId = item.equipment_group_uuid;
    const isSelected = (egId === selected);

    return (<SubNav.Item selected={isSelected} className="highlight eg-card p-0">
        <SubNav.Card
            onClick={onSelect.bind(this, item)} >
            <Row className={`p-0 m-0`}>
                <Col lg={9} md={9} sm={9} className="p-0 m-0">
                    <SubNav.Name bullet={true}>
                        {item.equipment_group_name}
                    </SubNav.Name>
                </Col>
            </Row>
            {!item.vehicle.is_truck && (
                <Row className="p-0 m-0">
                    <SubNav.Display2>
                        <div className="equipment-mapping-container">
                            {item.vehicle.name}
                            {item.vehicle.name && item.implement.name && <i className="fa fa-link i-chain" aria-hidden="true" />}
                            {item.implement.name}
                        </div>
                    </SubNav.Display2>
                </Row>
            )}
            <Row className="p-0 m-0">
                <SubNav.Display2>
                    {item.primary_category_name && <>
                        <span>
                            <i className="fa fa-truck i-category" aria-hidden="true" />
                            {item.primary_category_name}
                        </span>
                    </>}
                </SubNav.Display2>
            </Row>
            <Row className="p-0 m-0">
                <SubNav.DateRange
                    start={item.start_date}
                    end={item.end_date}
                    alive={item.alive}
                />
            </Row>
        </SubNav.Card>
    </SubNav.Item>);
};
